var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 32,
    viewBox: "0 0 63 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61.0348,
    height: 30.0174,
    rx: 15.0087,
    fill: "#14213D",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9239,
    cy: 15.9239,
    r: 12.9239,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark_mode.895528db3889f2a29b5f507efdd92b9c.svg";
export { ForwardRef as ReactComponent };